import React, { useState, useEffect, useMemo } from "react";
import { Navbar, Sidebar, SplashScreen } from "../../components/index";
import { Outlet } from "react-router-dom";
import { Navigate } from "react-router-dom";
import "./client.css";
import { useSelector } from "react-redux";
import active_Home from "../../assests/home.png";
import Inbox from "../../assests/inbox.png";
import Dashboard from "../../assests/dashboard.png";
import Programs from "../../assests/programs.png";
import Campaigns from "../../assests/campaigns.png";
import Insight from "../../assests/insight.png";
import Setting from "../../assests/settings.png";
// import Reports from "../../assests/reports.png"
import Leads from "../../assests/leads.png";
import Home from "../../assests/home_inactive.png";
import active_dashboard from "../../assests/dashboard_active.png";
import active_settings from "../../assests/setting_active.png";
import active_campaign from "../../assests/campaign_active.png";
// import active_reports from "../../assests/reports_active.png"
import analytics_icon from "../../assests/imgs/Analytics.png";
import analytics_inactive from "../../assests/imgs/Analytics-inactive.png";
import active_inbox from "../../assests/active_inbox.png";
import active_programs from "../../assests/programs_active.png";
import active_leads from "../../assests/leads_active.png";
import { SubSidebar } from "../../components/index";
import { useLocation } from "react-router-dom";
import { getAccountStatus } from "../../services/ApiService";
import {
  applySubscriptionToSidebarOptions,
  applySubscriptionToSubSidebarOptions,
} from "../../utils/subscriptionAccess";
import SubscriptionGate from "../../components/client/SubscriptionGate";
import SubscriptionPaywallBanner from "../../components/client/SubscriptionPaywallBanner";
import { useRef } from "react";
import gsap from "gsap";

const ClientDashboard = ({ navbarRef, sidebar, contentRef }) => {
  const user = useSelector((state) => state?.user);
  const location = useLocation();
  const [tab, setTab] = useState("");
  const [isOpenSidebar, setIsOpenSidebar] = useState(false);
  const [accountStatus, setAccountStatus] = useState({});
  const [showSplash, setShowSplash] = useState(true);
  const [isGooleAnalytics, setIsGoogleAnalytics] = useState(false);
  const splashRef = useRef();

  let clientSidebarOptions = [
    // { label: 'Home', path: '',icon_classnames:"bi bi-house", inactive:Home,active:active_Home,enable:true },
    {
      label: "Dashboard",
      path: "dashboards/home",
      icon_classnames: "bi bi-speedometer",
      inactive: Dashboard,
      active: active_dashboard,
      enable: user?.client_id && user?.status ? true : false,

      option_list: [
        // { name:'Home',path:'dashboards/home'},
        { name: "Paid  Social", path: "dashboards/paid_social" },
        { name: "Organic Social", path: "dashboards/organic_social" },
        { name: "Paid Media", path: "dashboards/paid_media" },
        { name: "Own Media", path: "dashboards/owned_media" },
      ],
    },

    {
      label: "Programs",
      path: "programs",
      icon_classnames: "bi bi-graph-down",
      inactive: Programs,
      active: active_programs,
      enable: user?.client_id ? true : false,
      option_list: [],
    },
    {
      label: "Campaigns",
      path: "campaigns",
      icon_classnames: "bi bi-graph-down",
      inactive: Campaigns,
      active: active_campaign,
      enable: user?.client_id ? true : false,
      option_list: [],
    },
    {
      label: "Reports and Analytics",
      path: "reprots_analytics",
      icon_classnames: "bi bi-bar-chart",
      inactive: analytics_inactive,
      active: analytics_icon,
      enable: user?.client_id ? true : false,
      option_list: [],
    },

    {
      label: "Insights",
      path: "insights",
      icon_classnames: "bi bi-lightning-charge",
      inactive: Insight,
      option_list: [],
    },
    {
      label: "Settings",
      path:
        user?.role_id < 3
          ? "/client/settings/client_profile"
          : "/client/settings/user_profile",
      icon_classnames: "bi bi-gear",
      inactive: Setting,
      active: active_settings,
      enable: user?.client_id ? true : false,
      option_list: isOpenSidebar
        ? [
            { name: "User Profile", path: `/client/settings/user_profile` },
            { name: "Security", path: `/client/settings/security` },
            { name: "Members", path: `/client/settings/users` },
            ...(user?.role_id < 3
              ? [
                  {
                    name: "Payments",
                    path: `/client/settings/payments`,
                  },
                ]
              : []),
          ]
        : [],
    },
    // {
    //   label: "Organic Social",
    //   path: "organic-social",
    //   icon_classnames: "bi bi-graph-down",
    //   inactive: Campaigns,
    //   active: active_campaign,
    //   enable: user?.client_id ? true : false,
    //   option_list: [],
    // }

    // {
    //   label: "Inbox",
    //   path: "inbox",
    //   icon_classnames: "bi bi-inbox",
    //   inactive: Inbox,
    //   active: active_inbox,
    //   enable: false,
    //   option_list: [],
    // },

    // {
    //   label: "Leads",
    //   path: "Leads",
    //   icon_classnames: "bi bi-gear",
    //   inactive: Leads,
    //   active: active_leads,
    //   option_list: [],
    // },
  ];
  const [sidebarOptions, setSidebarOptions] = useState(clientSidebarOptions);

  useEffect(() => {
    if (location.pathname.startsWith("/client/settings")) {
      setTab("user_profile");
    } else {
      if (location.pathname.split("/")[2] != "") {
        setTab(location.pathname.split("/")[2]);
      } else {
        setTab(location.pathname.split("/")[1]);
      }
    }
  }, [location.pathname]);

  const handleAccountStatus = async () => {
    let result = await getAccountStatus();
    if (result?.success) {
      setAccountStatus(result?.platforms);
      if (result?.platforms["google_analytics"]?.is_account_linked) {
        setIsGoogleAnalytics(true);
      }
    }
  };

  useEffect(() => {
    handleAccountStatus();
    // Splash screen animation
    gsap.to(splashRef.current, {
      opacity: 0,
      scale: 1.5,
      duration: 2,
      ease: "easeIn",
      delay: 1, // Keep splash screen visible for 1 seconds
      onComplete: () => setShowSplash(false), // Hide splash after animation
    });
  }, []);

  useEffect(() => {
    if (!showSplash) {
      // Sidebar, Navbar, and Content animations
      gsap.from(sidebar.current, {
        x: -200,
        duration: 1.25,
        opacity: 0,
        ease: "easeIn",
        onComplete: () => {
          if (sidebar.current && sidebar.current.style.transform)
            sidebar.current.style.transform = "";
        },
      });

      gsap.from(navbarRef.current, {
        y: -100,
        duration: 1.25,
        opacity: 0,
        ease: "easeIn",
        onComplete: () => {
          if (navbarRef.current && navbarRef.current.style.transform)
            navbarRef.current.style.transform = "";
        },
      });
      gsap.from(contentRef.current, {
        y: 500,
        duration: 1.25,
        opacity: 0,
        ease: "easeIn",
        onComplete: () => {
          if (contentRef.current && contentRef.current.style.transform)
            contentRef.current.style.transform = "";
        },
      });
    }
  }, [showSplash]);

  useEffect(() => {
    if (user?.clients?.length > 1) {
      clientSidebarOptions = [
        {
          label: "Home",
          path: "/client/",
          icon_classnames: "bi bi-house",
          inactive: Home,
          active: active_Home,
          enable: true,
        },
        ...clientSidebarOptions,
      ];
      setSidebarOptions(clientSidebarOptions);
    }
  }, [user?.clients]);

  useEffect(() => {
    if (user?.client_id) {
      setSidebarOptions((prev) => {
        return prev?.map((link) => {
          if (
            link?.label === "Leads" ||
            link?.label === "Insights" ||
            link?.label === "Inbox"
          ) {
            return { ...link, enable: false };
          }
          if (user?.status) {
            return { ...link, enable: true };
          } else if (link?.label === "Dashboard") {
            return { ...link, enable: true };
          }
          return { ...link, enable: false };
        });
      });
    }
  }, [user?.client_id]);

  if (accountStatus["google_ads"]?.is_account_linked) {
    clientSidebarOptions = [
      ...clientSidebarOptions,
      // {
      //   label: "Ads",
      //   path: "list_ads",
      //   icon_classnames: "bi bi-graph-down",
      //   inactive: Campaigns,
      //   active: active_campaign,
      //   enable: user?.client_id ? true : false,
      //   option_list: [],
      // },
    ];
  }

  const baseSubSidebarOptions = useMemo(() => {
    const options = [];
    if (user?.role_id < 3) {
      options.push({
        label: "Client Profile",
        path: `/client/settings/client_profile`,
      });
    }
    options.push(
      { label: "User Profile", path: `/client/settings/user_profile` },
      { label: "Security", path: `/client/settings/security` },
      { label: "Members", path: `/client/settings/users` },
    );
    if (user?.role_id < 3) {
      options.push({ label: "Payments", path: `/client/settings/payments` });
    }
    options.push({
      label: "Integrations",
      path: `/client/settings/integrations`,
    });
    return options;
  }, [user?.role_id]);

  const clientSubSidebarOptions = useMemo(
    () => applySubscriptionToSubSidebarOptions(baseSubSidebarOptions, user),
    [baseSubSidebarOptions, user],
  );

  const gatedSidebarOptions = useMemo(
    () => applySubscriptionToSidebarOptions(sidebarOptions, user),
    [sidebarOptions, user],
  );
  // if(isGooleAnalytics)
  //   clientSubSidebarOptions.push(
  //   { label: "Google Analytics",path: "/client/settings/analytics"}
  // )

  if (!user?.isLoggedIn || !user?.is_client) {
    return <Navigate to="/client/login" />;
  }

  return (
    <>
      <div className="client_main body-pd">
        {showSplash && <SplashScreen />}

        {/* sidebar */}
        {!showSplash && (
          <>
            <Sidebar
              sidebar={sidebar}
              setIsOpenSidebar={setIsOpenSidebar}
              sidebar_options={gatedSidebarOptions}
              tab={tab}
              isOpenSidebar={isOpenSidebar}
            />
            {location.pathname.startsWith("/client/settings") && (
              <SubSidebar options={clientSubSidebarOptions} />
            )}

            {/* <!-- main --> */}
            <div className="main">
              {/* Determine if the current path should hide the navbar and padding */}
              {(() => {
                const hideElements = [
                  "/campaigns/view-more",
                  "/organic-social/view-more",
                  "/owned_media/view-more",
                ].some((path) => location.pathname.includes(path));

                const hideNavbar =
                  hideElements ||
                  location.pathname.includes("reprots_analytics");

                return (
                  <>
                    {/* Navbar */}
                    {!hideNavbar && (
                      <Navbar
                        navbarRef={navbarRef}
                        setIsOpenSidebar={setIsOpenSidebar}
                      />
                    )}

                    {/* Content */}
                    <div
                      ref={contentRef}
                      className={`content_container ${
                        !hideElements &&
                        !location.pathname.includes("reprots_analytics")
                          ? "padding"
                          : ""
                      }`}
                    >
                      <SubscriptionPaywallBanner />
                      <SubscriptionGate>
                        <Outlet />
                      </SubscriptionGate>
                    </div>

                    <div className="footer">
                      <div className="footer_content">
                        <a href={`${process.env.REACT_APP_PRIVACY_POLICY_URL}`}>
                          Privacy Policy
                        </a>
                        |
                        <a
                          href={`${process.env.REACT_APP_TERMS_AND_CONDITIONS_URL}`}
                        >
                          Terms of Service
                        </a>
                      </div>
                    </div>
                  </>
                );
              })()}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ClientDashboard;
